module.exports = __webpack_public_path__ + "img/qr_code_wxmp.946b0068.jpg";